import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { LeadRequest } from './lead-request';

@Component({
  selector: 'cs-lead-requests',
  standalone: false,
  templateUrl: './lead-requests.component.html',
  styleUrls: ['./lead-requests.component.scss']
})
export class LeadRequestsComponent implements OnInit, OnDestroy {
  public leadRequests: Array<LeadRequest>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;

  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getLeadRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.leadRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: LeadRequest): void {
    this.router.navigate(['/sales/lead-requests/approval'], {
      queryParams: { leadRequestId: request.leadRequestId }
    });
    this.closeTodo.emit();
  }
}
